var _circle, _rect, _rect2, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentStatusRefunded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#1BC47D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15127_58941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15127_58941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15127_58941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15127_58941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7043 13.8354L7.86979 10.8564V9.94341H9.40281C9.74434 9.94341 10.0405 9.83734 10.2912 9.62518C10.542 9.41296 10.696 9.1472 10.7531 8.82789H7.45312V7.87997H10.6431C10.5317 7.65192 10.363 7.46723 10.137 7.32591C9.91101 7.18459 9.66049 7.11393 9.38542 7.11393H7.45312V6.16602H12.5677V7.11393H11.2409C11.3282 7.21706 11.4092 7.33473 11.484 7.46695C11.5587 7.59918 11.616 7.73685 11.656 7.87997H12.5677V8.82789H11.719C11.6584 9.41157 11.4145 9.8989 10.9873 10.2899C10.5601 10.6809 10.0494 10.8797 9.45521 10.8863H9.21042L12.0199 13.8354H10.7043Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24479 13.3737C3.93924 12.8459 3.71007 12.3043 3.55729 11.7487C3.40451 11.1931 3.32812 10.6237 3.32812 10.0404C3.32812 8.17925 3.97396 6.59592 5.26563 5.29036C6.55729 3.98481 8.13368 3.33203 9.99479 3.33203H10.1406L8.80729 1.9987L9.97396 0.832031L13.3073 4.16536L9.97396 7.4987L8.80729 6.33203L10.1406 4.9987H9.99479C8.6059 4.9987 7.42535 5.48828 6.45313 6.46745C5.4809 7.44662 4.99479 8.63759 4.99479 10.0404C4.99479 10.4015 5.03646 10.7556 5.11979 11.1029C5.20313 11.4501 5.32813 11.7904 5.49479 12.1237L4.24479 13.3737ZM10.0156 19.1654L6.68229 15.832L10.0156 12.4987L11.1823 13.6654L9.84896 14.9987H9.99479C11.3837 14.9987 12.5642 14.5091 13.5365 13.5299C14.5087 12.5508 14.9948 11.3598 14.9948 9.95703C14.9948 9.59592 14.9531 9.24175 14.8698 8.89453C14.7865 8.54731 14.6615 8.20703 14.4948 7.8737L15.7448 6.6237C16.0503 7.15148 16.2795 7.69314 16.4323 8.2487C16.5851 8.80425 16.6615 9.3737 16.6615 9.95703C16.6615 11.8181 16.0156 13.4015 14.724 14.707C13.4323 16.0126 11.8559 16.6654 9.99479 16.6654H9.84896L11.1823 17.9987L10.0156 19.1654Z",
    fill: "#0B5033"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusRefunded);
export default __webpack_public_path__ + "static/media/payment_status_refunded.29514a5cdf744e6c8bb2bcaa0a969bbd.svg";
export { ForwardRef as ReactComponent };